import { createSlice } from '@reduxjs/toolkit';

// Load user from localStorage if available
const loadUser = () => {
    try {
        const serializedUser = localStorage.getItem('user');
        if (!serializedUser) {
            return null;
        }
        const userData = JSON.parse(serializedUser);
        return userData.user; // Match your existing state structure
    } catch (err) {
        localStorage.removeItem('user'); // Clear invalid data
        return null;
    }
};

// Check if user is authenticated from localStorage
const checkAuthenticated = () => {
    try {
        return Boolean(localStorage.getItem('user'));
    } catch (err) {
        return false;
    }
};

const initialState = {
    isAuthenticated: checkAuthenticated(),
    user: loadUser(),
    loading: false,
    error: null
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
            if (action.payload) {
                state.error = null;
            }
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        loginSuccess: (state, action) => {
            state.isAuthenticated = true;
            state.user = action.payload.user;
            state.loading = false;
            state.error = null;
            // Save to localStorage
            localStorage.setItem('user', JSON.stringify(action.payload));
        },
        logout: (state) => {
            state.isAuthenticated = false;
            state.user = null;
            state.loading = false;
            state.error = null;
            // Clear localStorage
            localStorage.removeItem('user');
            localStorage.removeItem('token');
        }
    }
});

export const { setLoading, setError, loginSuccess, logout } = authSlice.actions;

export default authSlice.reducer; 